import { Button } from "@mui/material"
import classNames from "classnames"
import Icon from "components/Icon"
import css from "./CTABtn.module.scss"

const CTABtn = ({
  children,
  wide = false,
  type = "small",
  iconLeft,
  iconRight,
  onClick,
  style,
  className,
  iconSize = 22,
}) => {
  // Give the Ripple a chance to show before moving on
  function handleOnClick() {
    setTimeout(onClick, 200)
  }

  return <Button
    className={classNames(className, css.ctaBtn, css[type], "ellipsis", {
      [css.wide]: wide,
      [css.iconOnly]: !children,
    })}
    onClick={handleOnClick}
    style={style}>
    {iconLeft && <Icon name={iconLeft} size={iconSize} />}
    {children && children}
    {iconRight && <Icon name={iconRight} size={iconSize} />}
  </Button>
}

export default CTABtn
